import api from "../config/api";
import { EmployeeBreak } from "../types/EmployeeBreak";

const API_URL = "/employeeBreak";

export const insertEmployeeStartBreak = (data: EmployeeBreak) =>
  api.post(`${API_URL}/`, data).then((res) => {
    console.log("data", res.data);

    return res.data;
  });

export const updateEmployeeEndBreak = (data: EmployeeBreak) =>
  api.post(`${API_URL}/`, data).then((res) => res.data);

export const getSingleEmployeeBreak = (id: string) =>
  api.get(`${API_URL}/?id=${id}`).then((res) => res.data.data);

export const getTotalBreakByDateIfCheckedOut = (
  employeeId: string,
  date: string,
) =>
  api
    .get(`${API_URL}/?employeeId=${employeeId}&date=${date}&flag=checkedOut`)
    .then((res) => res.data.data);

export const getTotalBreakEmployeeByDate = (employeeId: string, date: string) =>
  api
    .get(`${API_URL}/?employeeId=${employeeId}&date=${date}&flag=summary`)
    .then((res) => res.data.data);
